import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurvey = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4448 9.82446L9.82397 12.4453C9.67769 12.5916 9.50402 12.7077 9.31286 12.7868C9.12171 12.866 8.91683 12.9068 8.70992 12.9067H2.66875C2.25103 12.9067 1.85043 12.7408 1.55506 12.4454C1.25969 12.1501 1.09375 11.7495 1.09375 11.3317V2.66924C1.09375 2.25152 1.25969 1.85091 1.55506 1.55555C1.85043 1.26018 2.25103 1.09424 2.66875 1.09424H11.3312C11.749 1.09424 12.1496 1.26018 12.4449 1.55555C12.7403 1.85091 12.9062 2.25152 12.9062 2.66924V8.71041C12.9063 8.91732 12.8655 9.1222 12.7863 9.31335C12.7072 9.5045 12.5911 9.67818 12.4448 9.82446V9.82446Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 5.5L10 5.5",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 8.5H7",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSurvey);
export default ForwardRef;
